"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.ContentTranslatedAction=void 0;var e;(function(t){t.Translate="Translate",t.Untranslate="Untranslate"})(e||(exports.ContentTranslatedAction=e={}));
//# sourceMappingURL=ContentTranslatedAction.js.map
